import React from "react";
import '../App.css';

const About =() =>{
   return (
      <div className="about">
         <p className="nice-para">Developer's mail: <a href="mailto: moloy.ghosh.cse@gmail.com">Send Email</a></p>
      </div>
   );
};

export default About;